import React from "react";
import MainContent from "./components/common/main-content/MainContent";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { toast, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure({
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  transition: Zoom
})

const App: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={MainContent} />
      </Switch>
    </Router>
  );
};

export default App;
